/**
 * SelfAbout storefront hotfix — brand, banner, active nav, hover media, newsletter UX.
 * Theme-level (not extension CDN), stays permanent.
 */
(function () {
  // Dead Bundles collection URL → filtered Shop (Bundles app products only).
  (function redirectDeadBundlesCollection() {
    var path = (window.location.pathname || "/").replace(/\/$/, "") || "/";
    var search = window.location.search || "";
    if (/\/collections\/(bundles|everyday-carry)$/i.test(path)) {
      window.location.replace("/collections/all?sa_type=bundle");
      return;
    }
    if (/[?&]sa_type=kit(?:&|$)/i.test(search)) {
      try {
        var u = new URL(window.location.href);
        u.searchParams.delete("sa_type");
        u.searchParams.set("sa_type", "bundle");
        window.history.replaceState({}, "", u.pathname + u.search + u.hash);
      } catch (_e) {}
    }
  })();

  /* Shopify captcha / password: mount full SelfAbout nav, then leave body alone. */
  var saPath = (window.location.pathname || "/").replace(/\/$/, "") || "/";
  var SA_SYSTEM = /^\/(challenge|password)$/i.test(saPath);
  if (SA_SYSTEM) {
    (function mountSystemNav() {
      var ITEMS = [
        { label: "Home", href: "/", key: "home" },
        { label: "Shop", href: "/collections/all", key: "shop" },
        { label: "Bundles", href: "/collections/all?sa_type=bundle", key: "bundles" },
        { label: "Collections", href: "/collections", key: "collections" },
        { label: "About", href: "/pages/about", key: "about" },
        { label: "Contact", href: "/pages/contact", key: "contact" },
      ];
      var root = document.documentElement;
      try {
        root.setAttribute("data-sa-challenge", "1");
        root.setAttribute("data-sa-nav", "contact");
        root.classList.add("sa-system-page", "sa-paint-ready", "sa-header-ready");
      } catch (_c) {}

      function pinBrandLogo(header) {
        if (!header || header.getAttribute("data-sa-brand-pinned") === "1") return;
        var meta = document.querySelector('meta[name="selfabout-brand-logo"]');
        var logoUrl =
          (window.__SA_BRAND && window.__SA_BRAND.logo) ||
          (meta && meta.getAttribute("content")) ||
          "";
        var brandMeta = document.querySelector('meta[name="selfabout-shop-name"]');
        var brand = (brandMeta && brandMeta.getAttribute("content")) || "SelfAbout";
        var hosts = header.querySelectorAll(
          ".header-logo, .header-logo__image-container, [data-testid='header-logo'], a.header__heading-link"
        );
        for (var i = 0; i < hosts.length; i++) {
          var node = hosts[i];
          /* Prefer SSR/theme <img> — never write SelfAbout text into logo hosts */
          var themeImg =
            node.querySelector("img.sa-brand-logo, img.header-logo__image") ||
            node.querySelector("img");
          if (themeImg) {
            themeImg.classList.add("sa-brand-logo");
            node.classList.add("sa-brand-logo-host");
            root.classList.add("sa-has-brand-logo");
            continue;
          }
          if (logoUrl) {
            var img = document.createElement("img");
            img.className = "sa-brand-logo";
            img.src = logoUrl;
            img.alt = brand;
            img.decoding = "async";
            img.setAttribute("width", "120");
            img.setAttribute("height", "32");
            img.setAttribute("fetchpriority", "high");
            node.replaceChildren(img);
            node.classList.add("sa-brand-logo-host");
            root.classList.add("sa-has-brand-logo");
          }
          /* If no logo URL and no img: leave empty — do NOT textContent brand */
        }
        header.setAttribute("data-sa-brand-pinned", "1");
      }

      function buildNav() {
        var nav = document.createElement("ul");
        nav.id = "sa-fixed-nav";
        nav.className = "sa-fixed-nav";
        nav.setAttribute("role", "list");
        nav.setAttribute("aria-label", "Primary");
        for (var i = 0; i < ITEMS.length; i++) {
          var item = ITEMS[i];
          var li = document.createElement("li");
          var a = document.createElement("a");
          a.href = item.href;
          a.textContent = item.label;
          a.setAttribute("data-sa-nav-key", item.key);
          li.appendChild(a);
          nav.appendChild(li);
        }
        return nav;
      }

      function hideThemeMenu(header) {
        if (!header) return;
        var nodes = header.querySelectorAll(
          "header-menu, overflow-list, .header__inline-menu, nav.header__inline-menu, .overflow-list__button, .overflow-menu"
        );
        for (var i = 0; i < nodes.length; i++) {
          nodes[i].style.setProperty("display", "none", "important");
          nodes[i].style.setProperty("visibility", "hidden", "important");
          nodes[i].style.setProperty("pointer-events", "none", "important");
        }
      }

      function place() {
        var header =
          document.querySelector("#header-component") ||
          document.querySelector("header-component");
        if (window.matchMedia && window.matchMedia("(max-width:899px)").matches) {
          if (header) pinBrandLogo(header);
          root.classList.add("sa-nav-placed");
          return true;
        }
        if (typeof window.__saPlaceNav === "function") {
          try {
            window.__saPlaceNav();
            root.classList.add("sa-nav-placed");
            return true;
          } catch (_e) {}
        }
        if (!header) return false;
        var center =
          header.querySelector(".header__columns .header__column--center") ||
          header.querySelector(".header__column--center") ||
          header.querySelector("[data-testid='header-top-center']") ||
          header.querySelector(".header__columns");
        if (!center) return false;
        hideThemeMenu(header);
        pinBrandLogo(header);
        var allNavs = center.querySelectorAll("#sa-fixed-nav, .sa-fixed-nav");
        if (allNavs.length > 1) {
          for (var k = 1; k < allNavs.length; k++) {
            allNavs[k].remove();
          }
        }
        var nav = document.getElementById("sa-fixed-nav");
        if (!nav) nav = buildNav();
        if (nav.parentNode !== center) center.appendChild(nav);
        header.classList.add("sa-desktop-nav");
        root.classList.add("sa-nav-placed", "selfabout-js", "sa-nav-ready");
        return true;
      }

      function boot() {
        place();
        var tries = 0;
        var timer = window.setInterval(function () {
          tries += 1;
          if (place() || tries >= 20) window.clearInterval(timer);
        }, 150);
      }
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", boot);
      } else {
        boot();
      }
      window.addEventListener("pageshow", function () {
        place();
      });
    })();
    return;
  }

  /* Strip mojibake leftovers from theme settings / legacy UTF-8 misreads */
  function scrubMojibake(root) {
    var map = [
      [/â€¹/g, "<"],
      [/â€º/g, ">"],
      [/â†’/g, ""],
      [/Â·/g, " - "],
      [/Â-/g, " - "],
      [/Â\s*-\s*/g, " - "],
      [/â€¦/g, "..."],
      [/â€“/g, "-"],
      [/â€”/g, "-"],
      [/Ã¢â‚¬â€œ/g, "-"],
    ];
    var walk = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walk.nextNode())) {
      var parent = node.parentElement;
      if (!parent) continue;
      var tag = parent.tagName;
      if (tag === "SCRIPT" || tag === "STYLE" || tag === "NOSCRIPT" || tag === "TEXTAREA") continue;
      var text = node.nodeValue;
      if (!text || text.indexOf("Â") === -1 && text.indexOf("â") === -1 && text.indexOf("Ã") === -1) continue;
      var next = text;
      for (var i = 0; i < map.length; i++) next = next.replace(map[i][0], map[i][1]);
      next = next.replace(/\s{2,}/g, " ");
      if (next !== text) node.nodeValue = next;
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      scrubMojibake(document.body);
    });
  } else {
    scrubMojibake(document.body);
  }

  function rewriteBundlesMenuLinks() {
    var links = document.querySelectorAll("a[href]");
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute("href") || "";
      var label = (links[i].textContent || "").replace(/\s+/g, " ").trim().toLowerCase();
      var isDead =
        /\/collections\/(bundles|everyday-carry)(\/|$|\?|#)/i.test(href) ||
        /sa_type=kit/i.test(href);
      var isPlainAll =
        /\/collections\/all\/?$/i.test((href.split("?")[0] || "")) &&
        !/sa_type=(?:bundle|kit)/i.test(href);
      var looksLikeBundles =
        /^(bundles|shop bundles|browse bundles|view all bundles|view bundles)$/i.test(label) ||
        (/bundle/i.test(label) && /^(shop|browse|view)/i.test(label));
      if (isDead || (isPlainAll && looksLikeBundles)) {
        links[i].setAttribute("href", "/collections/all?sa_type=bundle");
      }
    }
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", rewriteBundlesMenuLinks);
  } else {
    rewriteBundlesMenuLinks();
  }
  [200, 800].forEach(function (ms) {
    window.setTimeout(rewriteBundlesMenuLinks, ms);
  });

  // Inject critical product-nav CSS from JS so stale theme CSS fingerprints cannot hide Shop.
  (function injectProductNavCss() {
    if (document.getElementById("sa-chrome-nav-critical")) return;
    var css =
      '@media (min-width:900px){' +
      'html[data-sa-nav="shop"] header a.menu-list__link[href*="/collections/all-accessories"],' +
      'html[data-sa-nav="shop"] header-component a.menu-list__link[href*="/collections/all-accessories"]{' +
      'color:#047857!important;-webkit-text-fill-color:#047857!important;font-weight:700!important;' +
      'text-decoration:none!important;border:0!important;box-shadow:none!important;background:transparent!important}' +
      'html[data-sa-nav="shop"] header a.menu-list__link[href*="/collections/all-accessories"] .menu-list__link-title,' +
      'html[data-sa-nav="shop"] header-component a.menu-list__link[href*="/collections/all-accessories"] .menu-list__link-title{' +
      'color:#047857!important;-webkit-text-fill-color:#047857!important;font-weight:700!important;' +
      'text-decoration:underline!important;text-decoration-color:#047857!important;' +
      'text-decoration-thickness:2px!important;text-underline-offset:.35em!important}' +
      '}' +
      'html[data-sa-nav="shop"] .menu-drawer a[href*="/collections/all-accessories"]{' +
      'color:#047857!important;-webkit-text-fill-color:#047857!important;font-weight:700!important;' +
      'background:rgba(4,120,87,.1)!important;border-radius:10px!important;text-decoration:none!important;box-shadow:none!important}';
    var style = document.createElement("style");
    style.id = "sa-chrome-nav-critical";
    style.textContent = css;
    (document.head || document.documentElement).appendChild(style);
  })();

  // Challenge page still loads theme chrome; strip SelfAbout footer so CAPTCHA is usable.
  if (/^\/challenge/i.test(window.location.pathname || "")) {
    document.documentElement.setAttribute("data-sa-challenge", "1");
  }

  var brandMeta = document.querySelector('meta[name="selfabout-shop-name"]');
  var BRAND = (brandMeta && brandMeta.getAttribute("content")) || "SelfAbout";
  var STORE_NAME_RE = /selfabout-test-store/gi;
  var routePath = window.location.pathname.replace(/\/$/, "") || "/";
  var CATEGORY_HANDLES = /\/collections\/(caps|watches|audio|covers|bottles)(\/|$)/i;
  var KITS_HANDLES = /\/collections\/(bundles|everyday-carry)(\/|$)/i;
  var SHOP_HANDLES = /\/collections\/(all|all-accessories|catalog|shop)(\/|$)/i;

  // Persist Shop (or bundles) highlight as early as possible on product pages.
  if (routePath.indexOf("/products/") === 0) {
    var earlyBundle =
      document.documentElement.getAttribute("data-sa-bundle-pdp") === "1" ||
      (function () {
        try {
          return sessionStorage.getItem("sa-nav") === "bundles";
        } catch (_e) {
          return false;
        }
      })();
    document.documentElement.setAttribute("data-sa-nav", earlyBundle ? "bundles" : "shop");
  }

  function replaceBrandText(value) {
    if (!value) return value;
    return String(value).replace(STORE_NAME_RE, BRAND);
  }

  function applyBrandLabel() {
    var selectors = [
      "header a[href='/']",
      "header a[href='/'] span",
      "header .header__heading-link",
      "header .header__heading",
      "[data-header-logo]",
      ".header-logo a",
      ".header-logo span",
      "a.header__heading-link",
      ".footer__copyright a",
      "small a[href='/']",
      ".selfabout-site-footer__logo",
    ];
    document.querySelectorAll(selectors.join(",")).forEach(function (node) {
      if (!node) return;
      /* Never mutate logo hosts — text wordmark flash (SelfAbout) */
      if (
        node.closest &&
        node.closest(
          ".header-logo, .sa-brand-logo-host, [data-testid='header-logo'], [data-sa-has-logo]"
        )
      ) {
        return;
      }
      if (node.querySelector && node.querySelector("img.sa-brand-logo, img.header-logo__image")) {
        return;
      }
      if (!node.children || node.children.length === 0) {
        var text = (node.textContent || "").trim();
        if (STORE_NAME_RE.test(text) || text === "SelfAbout") {
          node.textContent = BRAND;
        }
        return;
      }
      node.childNodes.forEach(function (child) {
        if (child.nodeType === 3) {
          var value = child.nodeValue || "";
          if (STORE_NAME_RE.test(value)) {
            child.nodeValue = replaceBrandText(value);
          }
        }
      });
    });

    if (document.title) {
      document.title = replaceBrandText(document.title);
    }
  }

  function applyBannerBrand() {
    var textNodes = document.querySelectorAll(
      "#header-group .announcement-bar__text, #header-group .announcement-bar__link, #header-group .announcement-bar a, #header-group .announcement-bar p"
    );
    var fallback = BRAND + " — clear bundles, honest savings";
    textNodes.forEach(function (node) {
      if (!node) return;
      var text = (node.textContent || "").replace(/\s+/g, " ").trim();
      if (!text || /[�\uFFFD]/.test(text) || text.length < 3) {
        node.textContent = fallback;
        return;
      }
      var next = replaceBrandText(text);
      if (/^SelfAbout\b/i.test(next)) {
        next = next.replace(/^SelfAbout/i, BRAND);
      } else if (/clear (kits|bundles)/i.test(next) && next.indexOf(BRAND) === -1) {
        next = BRAND + " — " + next.replace(/^[\s—\-–]+/, "");
      }
      if (next !== text) node.textContent = next;
    });
  }

  function setupNavActive() {
    /* Never hide SelfAbout primary "Collections" — only obsolete theme labels */
    var hideLabels = /^(stories|shipping\s*&\s*returns)$/i;
    var childLabels = /^(caps|watches|audio|covers|bottles)$/i;

    document.querySelectorAll("header a, .menu-drawer a").forEach(function (link) {
      if (
        link.closest &&
        link.closest("#sa-fixed-nav, #sa-fixed-drawer, .sa-drawer-cols, [data-sa-drawer-cols]")
      ) {
        link.classList.remove("selfabout-nav-hide");
        var wrap = link.closest("li, .list-menu__item, .menu-drawer__menu-item");
        if (wrap) wrap.classList.remove("selfabout-nav-hide");
        return;
      }
      var text = (link.textContent || "").replace(/\s+/g, " ").trim();
      if (hideLabels.test(text)) {
        link.classList.add("selfabout-nav-hide");
        var item = link.closest("li, .list-menu__item, .menu-drawer__menu-item");
        if (item) item.classList.add("selfabout-nav-hide");
      }
    });

    var navLinks = Array.from(
      document.querySelectorAll(
        "header nav a[href], header .header__menu a[href], header .menu-list a[href], header .list-menu a[href], header-component .menu-list a[href], .header .menu-list a[href], .menu-drawer a[href], a.menu-list__link[href], #sa-fixed-nav a[href], #sa-fixed-drawer a[href]"
      )
    ).filter(function (link) {
      if (link.classList.contains("selfabout-nav-hide")) return false;
      if (link.closest(".header__logo, .header-logo, [data-header-logo], .header__heading, footer, .mega-menu__content")) {
        return false;
      }
      if (link.classList.contains("header__heading-link")) return false;
      // Top-level menu only for desktop active matching (skip mega-menu product cards)
      if (link.closest(".mega-menu__content-list--products")) return false;
      return true;
    });

    function linkLabel(link) {
      return (link.textContent || "").replace(/\s+/g, " ").trim().toLowerCase();
    }

    function findNavByLabel(label) {
      var needle = String(label || "").toLowerCase();
      return (
        navLinks.find(function (link) {
          return linkLabel(link) === needle;
        }) ||
        navLinks.find(function (link) {
          var text = linkLabel(link);
          return text === needle || text.endsWith(" " + needle);
        })
      );
    }

    document
      .querySelectorAll(
        "header nav a, header .header__menu a, .menu-drawer a, header .menu-list a, header .list-menu a"
      )
      .forEach(function (link) {
        link.classList.remove("selfabout-nav-child", "selfabout-nav-parent");
        link.removeAttribute("data-sa-active");
        var wrap = link.closest("li, .list-menu__item, .menu-drawer__menu-item");
        if (wrap) {
          wrap.classList.remove("selfabout-nav-child-item", "selfabout-nav-parent-item");
        }
      });

    navLinks.forEach(function (link) {
      var label = linkLabel(link);
      /* Never overwrite SelfAbout primary keys (paintActive / CSS depend on them) */
      if (
        link.closest &&
        link.closest("#sa-fixed-nav, #sa-fixed-drawer") &&
        link.getAttribute("data-sa-nav-key")
      ) {
        return;
      }
      link.setAttribute("data-sa-nav-key", label.replace(/\s+/g, "-"));
      /* Browse Collections in SelfAbout drawer has its own card+accent UI —
         do not mark hardcoded bottles/caps/covers as flat theme children. */
      if (link.closest(".sa-drawer-cols, [data-sa-drawer-cols]")) return;
      var href = link.getAttribute("href") || "";
      var isChild =
        childLabels.test(label) ||
        /\/collections\/(caps|watches|audio|covers|bottles)(\/|$)/i.test(href);
      if (!isChild) return;
      link.classList.add("selfabout-nav-child");
      var childWrap = link.closest("li, .list-menu__item, .menu-drawer__menu-item");
      if (childWrap) childWrap.classList.add("selfabout-nav-child-item");
    });

    var categoriesLink = findNavByLabel("categories");
    if (categoriesLink) {
      categoriesLink.classList.add("selfabout-nav-parent");
      var parentWrap = categoriesLink.closest(
        "li, .list-menu__item, .menu-drawer__menu-item"
      );
      if (parentWrap) parentWrap.classList.add("selfabout-nav-parent-item");
    }

    function isBundlesPlp() {
      return /(?:^|[?&])sa_type=(?:bundle|kit)(?:&|$)/i.test(
        window.location.search || ""
      );
    }

    function routeNavKey() {
      if (routePath === "/" || routePath === "") return "home";
      if (routePath.indexOf("/pages/about") === 0) return "about";
      if (routePath.indexOf("/pages/contact") === 0) return "contact";
      if (
        routePath.indexOf("/pages/support") === 0 ||
        routePath.indexOf("/pages/shipping") === 0
      ) {
        return "contact";
      }
      if (routePath.indexOf("/products/") === 0) return "shop";
      if (isBundlesPlp()) return "bundles";
      return inferKeyFromCollectionPath(routePath) || "";
    }

    function normalizeNavKey(raw) {
      var s = String(raw || "")
        .toLowerCase()
        .replace(/\s+/g, "-")
        .trim();
      var allowed = {
        home: 1,
        shop: 1,
        bundles: 1,
        collections: 1,
        about: 1,
        contact: 1,
        support: 1,
      };
      if (allowed[s]) return s;
      /* Theme/drawer labels often prefix emoji ("ℹ️-about") — recover the known token */
      var known = [
        "home",
        "shop",
        "bundles",
        "collections",
        "about",
        "contact",
        "support",
      ];
      for (var i = 0; i < known.length; i++) {
        var k = known[i];
        if (s === k || s.endsWith("-" + k) || s.endsWith("_" + k)) return k;
      }
      return "";
    }

    function setDocumentNavKey(key) {
      var value = normalizeNavKey(key);
      var allowed = {
        home: 1,
        shop: 1,
        bundles: 1,
        collections: 1,
        about: 1,
        contact: 1,
        support: 1,
      };
      if (value && !allowed[value]) value = "";
      if (!value) value = routeNavKey();
      // Home page: never let an unrecognised key blank out "home" — theme nav
      // links whose textContent carries extra glyphs (e.g. "Home›") resolve to
      // an invalid key which collapses to "" and clears the active underline bar.
      if (!value && (routePath === "/" || routePath === "")) value = "home";
      // About / Contact: same — invalid theme labels must not clear SSR active state.
      if (!value && routePath.indexOf("/pages/about") === 0) value = "about";
      if (!value && routePath.indexOf("/pages/contact") === 0) value = "contact";
      // Product pages: always keep a real nav key (default Shop). Never blank.
      if (routePath.indexOf("/products/") === 0) {
        if (!value || value === "home") value = "shop";
      }
      // Bundles PLP must never collapse to Shop (same /collections/all path).
      if (isBundlesPlp() && (value === "shop" || !value)) value = "bundles";
      if (!value) {
        document.documentElement.removeAttribute("data-sa-nav");
        if (document.body) document.body.removeAttribute("data-sa-nav");
        return;
      }
      document.documentElement.setAttribute("data-sa-nav", value);
      if (document.body) document.body.setAttribute("data-sa-nav", value);
    }

    function setActiveLink(link) {
      document
        .querySelectorAll(
          "header nav a[aria-current], header .header__menu a[aria-current], header .menu-list a[aria-current], header .list-menu a[aria-current], .menu-drawer a[aria-current], header a.selfabout-nav-active, .menu-drawer a.selfabout-nav-active, a[data-sa-active='1'], a.menu-list__link[aria-current], #sa-fixed-nav a[aria-current], #sa-fixed-nav a.selfabout-nav-active, #sa-fixed-drawer a[aria-current], #sa-fixed-drawer a.selfabout-nav-active"
        )
        .forEach(function (item) {
          item.classList.remove("selfabout-nav-active");
          item.removeAttribute("aria-current");
          item.removeAttribute("data-sa-active");
        });

      navLinks.forEach(function (item) {
        item.classList.remove("selfabout-nav-active");
        item.removeAttribute("aria-current");
        item.removeAttribute("data-sa-active");
      });
      document
        .querySelectorAll(
          "#sa-fixed-nav > li > a[data-sa-nav-key], #sa-fixed-drawer > li > a[data-sa-nav-key]"
        )
        .forEach(function (item) {
          item.classList.remove("selfabout-nav-active");
          item.removeAttribute("aria-current");
          item.removeAttribute("data-sa-active");
        });
      document
        .querySelectorAll(
          "#sa-fixed-drawer .sa-drawer-cols__featured a.selfabout-nav-active, #sa-fixed-drawer .sa-drawer-cols__featured a[aria-current], #sa-fixed-nav .sa-col-panel__featured a.selfabout-nav-active, #sa-fixed-nav .sa-col-panel__featured a[aria-current]"
        )
        .forEach(function (item) {
          item.classList.remove("selfabout-nav-active");
          item.removeAttribute("aria-current");
          item.removeAttribute("data-sa-active");
        });

      if (link) {
        link.classList.add("selfabout-nav-active");
        link.setAttribute("aria-current", "page");
        link.setAttribute("data-sa-active", "1");
        var keyFromLink = normalizeNavKey(
          link.getAttribute("data-sa-nav-key") ||
            linkLabel(link).replace(/\s+/g, "-")
        );
        if (!keyFromLink) keyFromLink = routeNavKey();
        setDocumentNavKey(keyFromLink);
        // Top-level only — never mark Browse Collections featured chips as route-active.
        if (keyFromLink) {
          document
            .querySelectorAll(
              '#sa-fixed-nav > li > a[data-sa-nav-key="' +
                keyFromLink +
                '"], #sa-fixed-drawer > li > a[data-sa-nav-key="' +
                keyFromLink +
                '"]'
            )
            .forEach(function (item) {
              item.classList.add("selfabout-nav-active");
              item.setAttribute("aria-current", "page");
              item.setAttribute("data-sa-active", "1");
            });
        }
      } else if (routePath.indexOf("/products/") === 0) {
        setDocumentNavKey(
          document.documentElement.getAttribute("data-sa-nav") || "shop"
        );
      } else if (routePath === "/" || routePath === "") {
        /* Home page: never clear the nav key — keep "home" active */
        setDocumentNavKey("home");
      } else if (routePath.indexOf("/pages/about") === 0) {
        setDocumentNavKey("about");
      } else if (routePath.indexOf("/pages/contact") === 0) {
        setDocumentNavKey("contact");
      } else {
        setDocumentNavKey(routeNavKey());
      }
    }

    function activateNav(link) {
      if (!link) return;
      setActiveLink(link);
      /* Only highlight Collections on the hub (/collections), not category PLPs. */
      if (
        link.classList.contains("selfabout-nav-child") ||
        routePath === "/collections"
      ) {
        if (categoriesLink && categoriesLink !== link) {
          categoriesLink.classList.add("selfabout-nav-active");
          categoriesLink.setAttribute("aria-current", "true");
          categoriesLink.setAttribute("data-sa-active", "1");
        }
      }
    }

    function normalizeHref(href) {
      try {
        var url = new URL(href, window.location.origin);
        return (url.pathname.replace(/\/$/, "") || "/") + url.hash;
      } catch (error) {
        return href;
      }
    }

    function collectionFromBreadcrumb() {
      var crumb = document.querySelector(
        'nav[aria-label*="readcrumb" i] a[href*="/collections/"]:last-of-type, .breadcrumb a[href*="/collections/"]:last-of-type, [class*="breadcrumb"] a[href*="/collections/"]:last-of-type'
      );
      if (!crumb) return "";
      return normalizeHref(crumb.getAttribute("href") || "").split("#")[0] || "";
    }

    function inferKeyFromCollectionPath(path) {
      var p = String(path || "").replace(/\/$/, "") || "/";
      var search = "";
      try {
        search = window.location.search || "";
      } catch (_e) {}
      if (p === "/collections") return "collections";
      if (KITS_HANDLES.test(p) || /\/collections\/(bundles|everyday-carry)/i.test(p)) {
        return "bundles";
      }
      if (/\/collections\/all(\/|$)/i.test(p) && /(?:^|[?&])sa_type=(?:bundle|kit)(?:&|$)/i.test(search)) {
        return "bundles";
      }
      /* Shop catalog + specific collection PLPs → Shop.
         Only the hub /collections uses Collections (product rule / debug fc86b3). */
      if (
        CATEGORY_HANDLES.test(p) ||
        /\/collections\/(earbuds|caps|watches|audio|covers|bottles)(\/|$)/i.test(p) ||
        SHOP_HANDLES.test(p) ||
        /\/collections\/(all|all-accessories|catalog|shop)/i.test(p) ||
        p.indexOf("/collections/") === 0
      ) {
        return "shop";
      }
      return "";
    }

    function inferProductNavKey() {
      var crumb = collectionFromBreadcrumb();
      var fromCrumb = inferKeyFromCollectionPath(crumb);
      if (fromCrumb) return fromCrumb;

      try {
        var refPath = new URL(document.referrer || "", window.location.origin).pathname || "";
        var fromRef = inferKeyFromCollectionPath(refPath);
        if (fromRef) return fromRef;
      } catch (err) {
        /* ignore */
      }

      // Product tags / type hints in page JSON
      var blob = "";
      document.querySelectorAll('script[type="application/ld+json"]').forEach(function (el) {
        blob += " " + (el.textContent || "");
      });
      if (/kit|bundle/i.test(blob) && /Product/i.test(blob)) {
        /* weak signal — only if handle also hints */
      }
      if (/bundle|everyday-carry/i.test(routePath)) return "bundles";
      return "shop";
    }

    function activateByNavKey(key) {
      var k = normalizeNavKey(key) || String(key || "shop").toLowerCase();
      // Set early so href-based CSS works even if theme strips link classes.
      setDocumentNavKey(k);
      var link =
        document.querySelector(
          '#sa-fixed-nav > li > a[data-sa-nav-key="' + k + '"]'
        ) ||
        document.querySelector(
          '#sa-fixed-drawer > li > a[data-sa-nav-key="' + k + '"]'
        ) ||
        findNavByLabel(k);
      if (!link && /^(caps|watches|audio|covers|bottles)$/.test(k)) {
        link = findNavByLabel("categories") || findNavByLabel("collections");
      }
      // Never fall back to Shop for About/Contact/Bundles/Collections — that
      // painted Shop and then blanked the real page key via invalid label keys.
      if (
        !link &&
        k !== "bundles" &&
        k !== "collections" &&
        k !== "about" &&
        k !== "contact" &&
        k !== "support"
      ) {
        link = findNavByLabel("shop");
      }
      if (link) {
        activateNav(link);
        setDocumentNavKey(k);
        if (/^(caps|watches|audio|covers|bottles)$/.test(k) && categoriesLink) {
          categoriesLink.classList.add("selfabout-nav-active");
          categoriesLink.setAttribute("data-sa-active", "1");
        }
      }
    }

    // Bundles PLP shares /collections/all with Shop — prefer query, never path-only Shop match.
    if (isBundlesPlp()) {
      activateByNavKey("bundles");
      setDocumentNavKey("bundles");
      return;
    }

    /* Prefer SelfAbout fixed nav — theme/drawer labels often include emoji and
       used to wipe data-sa-nav on About/Contact after first paint. */
    var fixedDirect =
      document.querySelector(
        '#sa-fixed-nav > li > a[href], #sa-fixed-drawer > li > a[href]'
      ) &&
      (document.querySelector(
        '#sa-fixed-nav > li > a[data-sa-nav-key="' +
          (routeNavKey() || "") +
          '"]'
      ) ||
        document.querySelector(
          '#sa-fixed-drawer > li > a[data-sa-nav-key="' +
            (routeNavKey() || "") +
            '"]'
        ));
    if (fixedDirect && routeNavKey()) {
      activateByNavKey(routeNavKey());
      return;
    }

    var directMatch = navLinks.find(function (link) {
      if (
        link.closest &&
        link.closest(".sa-col-panel, .sa-drawer-cols, .sa-drawer-cols__list")
      ) {
        return false;
      }
      var raw = link.getAttribute("href") || "";
      try {
        var url = new URL(raw, window.location.origin);
        var pathOnly = (url.pathname.replace(/\/$/, "") || "/");
        if (pathOnly !== routePath && pathOnly !== routePath + "/") return false;
        // Ignore Bundles filter links when browsing plain Shop.
        if (/sa_type=(?:bundle|kit)/i.test(url.search || "")) return false;
        return true;
      } catch (_e) {
        var href = normalizeHref(raw);
        var pathOnly2 = href.split("#")[0] || "/";
        return pathOnly2 === routePath || pathOnly2 === routePath + "/";
      }
    });
    if (directMatch) {
      activateNav(directMatch);
      var matchedKey =
        normalizeNavKey(directMatch.getAttribute("data-sa-nav-key") || "") ||
        routeNavKey();
      if (matchedKey) setDocumentNavKey(matchedKey);
      return;
    }

    if (routePath === "/") {
      /* Also query #sa-fixed-nav directly — navLinks is snapshotted at call time
         and may not include nav links built after sa-chrome init. */
      var homeLink =
        document.querySelector('#sa-fixed-nav > li > a[data-sa-nav-key="home"]') ||
        document.querySelector('#sa-fixed-drawer > li > a[data-sa-nav-key="home"]') ||
        findNavByLabel("home");
      setActiveLink(homeLink);
      /* Even if no DOM link found yet, keep the CSS attribute correct */
      if (!homeLink) setDocumentNavKey("home");
      return;
    }

    // Product detail pages — always keep Shop (or bundles/category) highlighted
    if (routePath.indexOf("/products/") === 0) {
      var productKey = inferProductNavKey() || "shop";
      activateByNavKey(productKey);
      setDocumentNavKey(productKey);
      // Re-apply classes on every Shop/Bundles match after theme morph
      var shopLinks = navLinks.filter(function (link) {
        var href = (link.getAttribute("href") || "").toLowerCase();
        if (productKey === "bundles") {
          return (
            href.indexOf("sa_type=bundle") !== -1 ||
            href.indexOf("sa_type=kit") !== -1 ||
            href.indexOf("/collections/bundles") !== -1
          );
        }
        if (/^(caps|watches|audio|covers|bottles)$/.test(productKey)) {
          return href.indexOf("/collections/" + productKey) !== -1;
        }
        return href.indexOf("/collections/all") !== -1;
      });
      shopLinks.forEach(function (link) {
        link.classList.add("selfabout-nav-active");
        link.setAttribute("aria-current", "page");
        link.setAttribute("data-sa-active", "1");
      });
      return;
    }

    var crumbPath = collectionFromBreadcrumb();
    var pathForNav = crumbPath || routePath;

    /* Search is its own surface — do not inherit Shop active state */
    if (routePath === "/search") {
      setActiveLink(null);
      document.documentElement.removeAttribute("data-sa-nav");
      if (document.body) document.body.removeAttribute("data-sa-nav");
      return;
    }

    if (
      pathForNav.indexOf("/collections/") === 0 ||
      pathForNav === "/collections"
    ) {
      var collectionKey = inferKeyFromCollectionPath(pathForNav) || "shop";
      activateByNavKey(collectionKey);
      return;
    }

    if (routePath.indexOf("/pages/about") === 0) {
      activateByNavKey("about");
      return;
    }

    if (routePath.indexOf("/pages/contact") === 0) {
      activateByNavKey("contact");
      return;
    }

    if (
      routePath.indexOf("/pages/support") === 0 ||
      routePath.indexOf("/pages/shipping") === 0
    ) {
      activateByNavKey("contact");
      return;
    }
  }

  function ensureNewsletterMessage(form) {
    var msg = form.querySelector("[data-newsletter-msg]");
    if (msg) return msg;
    msg = document.createElement("p");
    msg.className = "selfabout-site-footer__newsletter-msg";
    msg.setAttribute("data-newsletter-msg", "");
    msg.setAttribute("data-success-text", "Thanks — you're on the list.");
    msg.setAttribute("role", "status");
    msg.setAttribute("aria-live", "polite");
    msg.hidden = true;
    form.appendChild(msg);
    return msg;
  }

  function setNewsletterMessage(form, type, text) {
    var msg = ensureNewsletterMessage(form);
    if (form && form._saNlHideTimer) {
      window.clearTimeout(form._saNlHideTimer);
      form._saNlHideTimer = null;
    }
    msg.hidden = false;
    msg.removeAttribute("hidden");
    msg.classList.remove(
      "selfabout-site-footer__newsletter-msg--error",
      "selfabout-site-footer__newsletter-msg--success",
      "is-visible"
    );
    msg.classList.add(
      "is-visible",
      type === "error"
        ? "selfabout-site-footer__newsletter-msg--error"
        : "selfabout-site-footer__newsletter-msg--success"
    );
    msg.setAttribute("role", type === "error" ? "alert" : "status");
    msg.textContent = text;
    if (type === "success") msg.setAttribute("data-sa-nl-js", "1");
    else msg.removeAttribute("data-sa-nl-js");

    if (type === "success") {
      form._saNlHideTimer = window.setTimeout(function () {
        msg.classList.add("is-leaving");
        window.setTimeout(function () {
          msg.hidden = true;
          msg.classList.remove(
            "is-visible",
            "is-leaving",
            "selfabout-site-footer__newsletter-msg--success"
          );
          msg.removeAttribute("data-sa-nl-js");
          msg.textContent = "";
          form._saNlHideTimer = null;
        }, 280);
      }, 6000);
    }
  }

  function clearInventedNewsletterSuccess(form) {
    var msg = form && form.querySelector("[data-newsletter-msg]");
    if (!msg || msg.getAttribute("data-sa-nl-js") !== "1") return;
    if (form._saNlHideTimer) {
      window.clearTimeout(form._saNlHideTimer);
      form._saNlHideTimer = null;
    }
    msg.hidden = true;
    msg.setAttribute("hidden", "");
    msg.classList.remove(
      "is-visible",
      "is-leaving",
      "selfabout-site-footer__newsletter-msg--success",
      "selfabout-site-footer__newsletter-msg--error"
    );
    msg.removeAttribute("data-sa-nl-js");
    msg.textContent = "";
  }

  function newsletterScrollRoot() {
    return (
      document.getElementById("sa-content-scroll") ||
      document.querySelector(".page-wrapper") ||
      null
    );
  }

  function scrollNewsletterIntoView(target, behavior) {
    if (!target) return;
    var reduced =
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var mode = reduced ? "auto" : behavior || "smooth";
    var scroller = newsletterScrollRoot();
    if (scroller && typeof scroller.scrollTo === "function") {
      var scrollerRect = scroller.getBoundingClientRect();
      var targetRect = target.getBoundingClientRect();
      var nextTop =
        scroller.scrollTop + (targetRect.top - scrollerRect.top) - 20;
      var max = Math.max(0, scroller.scrollHeight - scroller.clientHeight);
      if (!isFinite(nextTop) || nextTop < 0) nextTop = 0;
      if (nextTop > max) nextTop = max;
      /* Prefer landing on the footer Join block; if near end, pin to max */
      if (max - nextTop < 80) nextTop = max;
      scroller.scrollTo({ top: nextTop, behavior: mode });
      return;
    }
    try {
      target.scrollIntoView({ behavior: mode, block: "start" });
    } catch (err) {
      target.scrollIntoView(true);
    }
  }

  function scrollToNewsletterFooter() {
    if (window.__saNlScrollLock) return;
    window.__saNlScrollLock = true;
    holdNewsletterScroll(6000);

    var tries = 0;
    var lastHeight = -1;
    var stableHits = 0;

    function targetEl() {
      return document.querySelector(
        ".selfabout-site-footer__newsletter, #selfabout-site-footer, [data-selfabout-site-footer], .selfabout-site-footer"
      );
    }

    function heightNow() {
      var scroller = newsletterScrollRoot();
      return scroller ? scroller.scrollHeight : document.body ? document.body.scrollHeight : 0;
    }

    function startScroll() {
      var target = targetEl();
      if (!target) {
        window.__saNlScrollLock = false;
        return;
      }
      scrollNewsletterIntoView(target, "smooth");
      [450, 1100, 1800, 2600].forEach(function (delay) {
        window.setTimeout(function () {
          var t2 = targetEl();
          if (t2) scrollNewsletterIntoView(t2, "auto");
        }, delay);
      });
      window.setTimeout(function () {
        window.__saNlScrollLock = false;
        clearNewsletterScrollHold();
      }, 3200);
    }

    function waitStable() {
      var target = targetEl();
      var ready =
        document.documentElement.classList.contains("sa-paint-ready") || tries > 20;
      var h = heightNow();
      if (target && ready) {
        if (h > 0 && h === lastHeight) stableHits += 1;
        else stableHits = 0;
        lastHeight = h;
        if (stableHits >= 2 || tries > 35) {
          startScroll();
          return;
        }
      }
      if (tries++ < 60) {
        window.setTimeout(waitStable, 90);
        return;
      }
      startScroll();
    }

    window.setTimeout(waitStable, 80);
  }

  function storeSet(key, value) {
    try {
      sessionStorage.setItem(key, value);
    } catch (err) {
      /* ignore */
    }
  }

  function storeGet(key) {
    try {
      return sessionStorage.getItem(key);
    } catch (err) {
      return null;
    }
  }

  function storeClear(key) {
    try {
      sessionStorage.removeItem(key);
    } catch (err) {
      /* ignore */
    }
  }

  function holdNewsletterScroll(ms) {
    var until = Date.now() + (ms || 5000);
    storeSet("sa-nl-hold-until", String(until));
    storeSet("sa-nl-scroll", "1");
  }

  function clearNewsletterScrollHold() {
    storeClear("sa-nl-scroll");
    storeClear("sa-nl-hold-until");
  }

  function ensureReturnTo(form) {
    var ret = form.querySelector('input[name="return_to"]');
    if (!ret) {
      ret = document.createElement("input");
      ret.type = "hidden";
      ret.name = "return_to";
      form.appendChild(ret);
    }
    // Path + join marker — captcha returns often omit customer_posted=true
    var path = (window.location.pathname || "/").split("#")[0] || "/";
    ret.value = path + (path.indexOf("?") >= 0 ? "&" : "?") + "sa_join=ok";
  }

  function wireCaptcha(form) {
    form.setAttribute("data-shopify-captcha", "true");
    try {
      if (
        window.Shopify &&
        Shopify.captcha &&
        typeof Shopify.captcha.protect === "function"
      ) {
        Shopify.captcha.protect(form);
      }
    } catch (err) {
      /* ignore */
    }
  }

  function escapeContactErrorPage() {
    if (!/^\/contact\/?$/i.test(window.location.pathname)) return false;
    var haystack = (
      (document.title || "") +
      " " +
      (document.body ? document.body.innerText : "")
    ).slice(0, 2000);
    if (
      !/missing\s+captcha\s+token|invalid\s+parameters|something went wrong/i.test(
        haystack
      )
    ) {
      return false;
    }
    storeSet("sa-nl-pending", String(Date.now()));
    storeSet("sa-nl-result", "error");
    window.location.replace("/");
    return true;
  }

  function clearNewsletterBusy(form) {
    var btn = form && form.querySelector(".selfabout-site-footer__newsletter-submit");
    if (!btn) return;
    btn.classList.remove("is-busy");
    btn.removeAttribute("aria-busy");
    btn.disabled = false;
  }

  function setNewsletterBusy(form, on) {
    var btn = form && form.querySelector(".selfabout-site-footer__newsletter-submit");
    if (!btn) return;
    btn.classList.toggle("is-busy", on);
    btn.setAttribute("aria-busy", on ? "true" : "false");
    btn.disabled = !!on;
  }

  function validateNewsletterEmail(value) {
    var v = String(value || "").trim();
    if (!v) return "Please enter your email.";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) return "Enter a valid email address.";
    return "";
  }

  function enhanceNewsletterForm() {
    // Mark challenge only if Join already set pending (not contact captcha).
    if (/^\/challenge/i.test(window.location.pathname || "")) {
      if (storeGet("sa-nl-pending")) {
        document.documentElement.setAttribute("data-sa-challenge", "1");
        storeSet("sa-nl-challenge", "1");
      }
      return;
    }

    if (escapeContactErrorPage()) return;

    document.querySelectorAll(".selfabout-site-footer__newsletter").forEach(function (form) {
      if (!(form instanceof HTMLFormElement)) return;
      if (form.dataset.saNewsletterBound === "1") return;
      form.dataset.saNewsletterBound = "1";

      // Custom inline errors — never native browser tooltips
      form.setAttribute("novalidate", "novalidate");

      var cleanAction =
        String(form.getAttribute("action") || "/contact").split("#")[0] || "/contact";
      form.setAttribute("action", cleanAction);
      form.setAttribute("data-shopify-captcha", "true");

      if (!form.querySelector('input[name="contact[accepts_marketing]"]')) {
        var marketing = document.createElement("input");
        marketing.type = "hidden";
        marketing.name = "contact[accepts_marketing]";
        marketing.value = "true";
        form.appendChild(marketing);
      }

      ensureReturnTo(form);
      ensureNewsletterMessage(form);
      wireCaptcha(form);
      clearNewsletterBusy(form);

      var emailInput = form.querySelector('input[name="contact[email]"]');
      if (emailInput) {
        emailInput.removeAttribute("required");
        ["focus", "input"].forEach(function (evt) {
          emailInput.addEventListener(evt, function () {
            if (evt === "focus") wireCaptcha(form);
            if (evt === "input") {
              var msg = form.querySelector("[data-newsletter-msg]");
              if (
                msg &&
                msg.classList.contains("selfabout-site-footer__newsletter-msg--error") &&
                msg.classList.contains("is-visible")
              ) {
                var liveErr = validateNewsletterEmail(emailInput.value);
                if (!liveErr) {
                  msg.hidden = true;
                  msg.classList.remove(
                    "is-visible",
                    "selfabout-site-footer__newsletter-msg--error"
                  );
                  msg.textContent = "";
                  emailInput.removeAttribute("aria-invalid");
                } else {
                  setNewsletterMessage(form, "error", liveErr);
                }
              }
            }
          });
        });
      }

      function blockInvalidJoin(event) {
        var err = validateNewsletterEmail(emailInput && emailInput.value);
        if (!err) return false;
        if (event) {
          event.preventDefault();
          event.stopPropagation();
          if (typeof event.stopImmediatePropagation === "function") {
            event.stopImmediatePropagation();
          }
        }
        setNewsletterBusy(form, false);
        setNewsletterMessage(form, "error", err);
        if (emailInput) {
          emailInput.setAttribute("aria-invalid", "true");
          try {
            emailInput.focus();
          } catch (_) {
            /* ignore */
          }
        }
        return true;
      }

      var submitBtn = form.querySelector(
        '.selfabout-site-footer__newsletter-submit, button[type="submit"], input[type="submit"]'
      );
      if (submitBtn) {
        /* Click capture: stop invalid Join before Shopify captcha hooks run */
        submitBtn.addEventListener(
          "click",
          function (event) {
            blockInvalidJoin(event);
          },
          true
        );
      }

      /* Submit capture: validate BEFORE wireCaptcha — captcha protect can navigate to /challenge */
      form.addEventListener(
        "submit",
        function (event) {
          if (blockInvalidJoin(event)) return;

          ensureReturnTo(form);
          wireCaptcha(form);

          if (emailInput) emailInput.removeAttribute("aria-invalid");
          setNewsletterBusy(form, true);
          storeSet("sa-nl-pending", String(Date.now()));
          holdNewsletterScroll(8000);
          storeClear("sa-nl-challenge");
          storeClear("sa-nl-result");
          if (emailInput && emailInput.value) {
            storeSet("sa-nl-email", String(emailInput.value));
          }
          /* Valid: do not preventDefault — native POST to /contact → Shopify /challenge */
        },
        true
      );
    });

    var returnedForm = document.querySelector(".selfabout-site-footer__newsletter");
    if (!returnedForm) return;
    clearNewsletterBusy(returnedForm);

    /* Contact success — never hijack scroll to footer Join (even after URL cleaned) */
    var contactOk =
      !!document.querySelector(".sa-ct-flash--ok") ||
      (!!document.querySelector("[data-selfabout-contact]") &&
        (/[?&]contact_posted=true/i.test(window.location.search || "") ||
          window.location.hash === "#sa-ct-panel" ||
          storeGet("sa-ct-success") === "1"));
    if (contactOk) {
      storeClear("sa-nl-pending");
      storeClear("sa-nl-challenge");
      storeClear("sa-nl-result");
      clearNewsletterScrollHold();
      return;
    }

    var params = window.location.search || "";
    var posted = /[?&]customer_posted=true/i.test(params);
    var joinReturn = /[?&]sa_join=ok(?:&|$|#)/i.test(params);
    var forcedError = /[?&]newsletter_error=/i.test(params);
    var pendingRaw = storeGet("sa-nl-pending");
    var pendingAge = pendingRaw ? Date.now() - parseInt(pendingRaw, 10) : -1;
    var pendingFresh = pendingAge >= 0 && pendingAge < 15 * 60 * 1000;
    var sawChallenge = storeGet("sa-nl-challenge") === "1";
    var fromChallenge = /\/challenge/i.test(document.referrer || "");
    var forcedResult = storeGet("sa-nl-result");
    var msgNode = returnedForm.querySelector("[data-newsletter-msg]");
    var liquidOk = !!(
      msgNode &&
      msgNode.getAttribute("data-sa-nl-js") !== "1" &&
      (msgNode.classList.contains(
        "selfabout-site-footer__newsletter-msg--success"
      ) ||
        (msgNode.classList.contains("is-visible") &&
          /thanks/i.test(msgNode.textContent || "")))
    );
    var liquidErr = !!(
      returnedForm.querySelector(
        "[data-newsletter-msg].selfabout-site-footer__newsletter-msg--error",
      )
    );

    /* Real Join confirmation — captcha Back must not invent Thanks */
    var shouldShowSuccess =
      !liquidErr &&
      (liquidOk || posted || (pendingFresh && joinReturn));

    if (forcedError || forcedResult === "error") {
      storeClear("sa-nl-pending");
      storeClear("sa-nl-challenge");
      storeClear("sa-nl-result");
      setNewsletterMessage(
        returnedForm,
        "error",
        /newsletter_error=captcha/i.test(params)
          ? "Security check failed. Please try Join again."
          : "Could not join. Please try again."
      );
      holdNewsletterScroll(6000);
      scrollToNewsletterFooter();
      return;
    }

    if (!shouldShowSuccess) {
      if (
        pendingFresh &&
        (sawChallenge || fromChallenge) &&
        !posted &&
        !joinReturn
      ) {
        storeClear("sa-nl-pending");
        storeClear("sa-nl-challenge");
        storeClear("sa-nl-result");
        clearNewsletterScrollHold();
        clearInventedNewsletterSuccess(returnedForm);
      }
      return;
    }

    if (shouldShowSuccess) {
      storeClear("sa-nl-pending");
      storeClear("sa-nl-challenge");
      storeClear("sa-nl-result");
      var okText =
        (returnedForm.querySelector("[data-newsletter-msg]") &&
          returnedForm
            .querySelector("[data-newsletter-msg]")
            .getAttribute("data-success-text")) ||
        "Thanks — you're on the list.";
      setNewsletterMessage(returnedForm, "success", okText);
      var emailInput2 = returnedForm.querySelector('input[name="contact[email]"]');
      if (emailInput2) emailInput2.value = "";
      holdNewsletterScroll(6000);
      scrollToNewsletterFooter();
      try {
        history.replaceState(null, "", window.location.pathname || "/");
      } catch (err) {
        /* ignore */
      }
    }
  }

  function enhanceMediaSwap() {
    // SelfAbout cards already render alt images in Liquid; ensure primary z-index
    document
      .querySelectorAll(
        ".selfabout-home-featured__media, .selfabout-home-kits__media"
      )
      .forEach(function (media) {
        var imgs = media.querySelectorAll("img");
        if (imgs.length < 2) return;
        imgs[0].classList.add(
          media.classList.contains("selfabout-home-kits__media")
            ? "selfabout-home-kits__img--primary"
            : "selfabout-home-featured__img--primary"
        );
        imgs[1].classList.add(
          media.classList.contains("selfabout-home-kits__media")
            ? "selfabout-home-kits__img--alt"
            : "selfabout-home-featured__img--alt"
        );
      });

    // Theme product cards: if a second image URL is present in markup, enable swap
    document.querySelectorAll("product-card, .product-card, .card-gallery").forEach(function (card) {
      if (card.querySelector(".sa-media-swap")) return;
      var media =
        card.querySelector(".card__media, .product-card__image, .media, .card-gallery") ||
        card;
      var imgs = media.querySelectorAll("img");
      if (imgs.length < 2) {
        var hoverSrc =
          card.getAttribute("data-hover-image") ||
          card.getAttribute("data-secondary-image") ||
          (imgs[0] && imgs[0].getAttribute("data-hover-src"));
        if (!hoverSrc || !imgs[0]) return;
        var wrap = document.createElement("span");
        wrap.className = "sa-media-swap";
        imgs[0].parentNode.insertBefore(wrap, imgs[0]);
        wrap.appendChild(imgs[0]);
        imgs[0].classList.add("sa-media-swap__img", "sa-media-swap__img--primary");
        var alt = imgs[0].cloneNode(true);
        alt.classList.add("sa-media-swap__img", "sa-media-swap__img--alt");
        alt.src = hoverSrc;
        alt.setAttribute("aria-hidden", "true");
        wrap.appendChild(alt);
        return;
      }
      var host = imgs[0].parentElement;
      if (!host) return;
      host.classList.add("sa-media-swap");
      imgs[0].classList.add("sa-media-swap__img", "sa-media-swap__img--primary");
      imgs[1].classList.add("sa-media-swap__img", "sa-media-swap__img--alt");
      imgs[1].setAttribute("aria-hidden", "true");
    });
  }

  function enhanceProductBackButton() {
    if (routePath.indexOf("/products/") !== 0) return;

    var existing = document.querySelector(".sa-product-back");
    if (existing && existing.classList.contains("sa-product-back--on-media")) {
      var hostOk = existing.closest(".sa-product-media-host");
      if (hostOk) return;
    }
    if (existing) existing.remove();

    function resolveBackHref() {
      try {
        var ref = document.referrer || "";
        if (ref) {
          var u = new URL(ref);
          if (u.origin === window.location.origin && u.pathname.indexOf("/products/") !== 0) {
            return u.pathname + u.search;
          }
        }
      } catch (err) {
        /* ignore */
      }
      var crumb = document.querySelector(
        'nav[aria-label*="readcrumb" i] a[href*="/collections/"]:last-of-type, .breadcrumb a[href*="/collections/"]:last-of-type, [class*="breadcrumb"] a[href*="/collections/"]'
      );
      if (crumb && crumb.getAttribute("href")) return crumb.getAttribute("href");
      return "/collections/all-accessories";
    }

    var back = document.createElement("a");
    back.className = "sa-product-back sa-product-back--on-media";
    back.href = resolveBackHref();
    back.setAttribute("aria-label", "Go back");
    back.innerHTML =
      '<span class="sa-product-back__icon" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" width="14" height="14" fill="none">' +
      '<path d="M15 5L8 12l7 7" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>' +
      "</svg></span>" +
      '<span class="sa-product-back__label">Back</span>';

    back.addEventListener("click", function (event) {
      // Normal navigation only — history.back() + view transitions hang the tab loader.
      event.preventDefault();
      var href = back.getAttribute("href") || "/collections/all-accessories";
      try {
        window.location.assign(href);
      } catch (err) {
        window.location.href = href;
      }
    });

    var media =
      document.querySelector(
        "media-gallery, .media-gallery, .product-media-constraint-wrapper, slideshow-component.product-media-gallery__slideshow--single-media, .product-media-gallery"
      ) || null;

    if (media) {
      var host =
        media.closest(
          ".product-media-gallery, .product-information__media, .media-gallery, .product-media-constraint-wrapper"
        ) || media;
      host.classList.add("sa-product-media-host");
      host.insertBefore(back, host.firstChild);
      return;
    }

    var details = document.querySelector(
      ".product-details, [id^='ProductInformation'], .product-information"
    );
    if (details) {
      details.insertBefore(back, details.firstChild);
      back.classList.remove("sa-product-back--on-media");
    }
  }

  function boot() {
    applyBrandLabel();
    applyBannerBrand();
    setupNavActive();
    enhanceNewsletterForm();
    enhanceMediaSwap();
    enhanceProductBackButton();
  }

  /* Soft Shop ↔ Bundles PLP chips — re-resolve single active nav key */
  document.addEventListener("selfabout:nav-active", function (event) {
    var key =
      (event && event.detail && event.detail.key) ||
      document.documentElement.getAttribute("data-sa-nav") ||
      "";
    try {
      document
        .querySelectorAll(
          "#sa-fixed-nav > li > a[data-sa-nav-key], #sa-fixed-drawer > li > a[data-sa-nav-key]",
        )
        .forEach(function (link) {
          var on = !!(key && link.getAttribute("data-sa-nav-key") === key);
          link.classList.toggle("selfabout-nav-active", on);
          if (on) {
            link.setAttribute("aria-current", "page");
            link.setAttribute("data-sa-active", "1");
          } else {
            link.removeAttribute("aria-current");
            link.removeAttribute("data-sa-active");
          }
        });
      if (key) {
        document.documentElement.setAttribute("data-sa-nav", key);
        if (document.body) document.body.setAttribute("data-sa-nav", key);
      }
    } catch (_nav) {}
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", boot);
  /* Arm novalidate as early as a click/tap — kills browser tooltips before submit */
  document.addEventListener(
    "pointerdown",
    function (event) {
      var form =
        event.target && event.target.closest
          ? event.target.closest(".selfabout-site-footer__newsletter")
          : null;
      if (form) {
        form.setAttribute("novalidate", "novalidate");
        var email = form.querySelector('input[name="contact[email]"]');
        if (email) email.removeAttribute("required");
      }
    },
    true
  );
  window.addEventListener("pageshow", function () {
    document.querySelectorAll(".selfabout-site-footer__newsletter").forEach(clearNewsletterBusy);
  });
  window.setTimeout(applyBrandLabel, 400);
  window.setTimeout(applyBannerBrand, 450);
  window.setTimeout(enhanceMediaSwap, 700);

  // Theme often re-renders header after load — light retries only (heavy loops freeze PDP clicks).
  var navRetryMs = routePath.indexOf("/products/") === 0
    ? [0, 400, 1200, 3000]
    : [0, 100, 300, 600, 1000, 1600, 2500, 4000];
  navRetryMs.forEach(function (ms) {
    window.setTimeout(setupNavActive, ms);
    window.setTimeout(enhanceProductBackButton, ms);
  });

  // Product pages: pin Shop/Bundles via attribute only — CSS does the rest. Do NOT thrash the DOM.
  if (routePath.indexOf("/products/") === 0) {
    function pinProductNavAttr() {
      var isBundle =
        document.documentElement.getAttribute("data-sa-bundle-pdp") === "1" ||
        !!document.querySelector("[data-selfabout-product][data-sa-kit='1'], [data-sa-bundle-pdp='1']") ||
        (function () {
          try {
            return sessionStorage.getItem("sa-nav") === "bundles";
          } catch (_e) {
            return false;
          }
        })();
      var key = isBundle ? "bundles" : "shop";
      document.documentElement.setAttribute("data-sa-nav", key);
      if (document.body) document.body.setAttribute("data-sa-nav", key);
    }
    pinProductNavAttr();
    window.setTimeout(pinProductNavAttr, 500);
    window.setTimeout(pinProductNavAttr, 2000);

    // Release stuck view-transition / zoom overlays that swallow all clicks.
    function unstickProductUi() {
      var blocker = document.getElementById("view-transition-render-blocker");
      if (blocker) blocker.remove();
      document.documentElement.classList.remove(
        "page-transition",
        "page-transition--loading",
        "vt-loading"
      );
      if (document.body) {
        document.body.classList.remove(
          "page-transition",
          "page-transition--loading",
          "vt-loading"
        );
        document.body.style.cursor = "";
        document.body.style.pointerEvents = "";
      }
      document.querySelectorAll("dialog[open]").forEach(function (d) {
        var label = ((d.className || "") + " " + (d.id || "")).toLowerCase();
        var isZoom =
          /zoom|media-modal|product-media/.test(label) ||
          (d.querySelector("img, .media") &&
            d.getBoundingClientRect().width > window.innerWidth * 0.8);
        if (isZoom) {
          try {
            d.close();
          } catch (err) {
            d.removeAttribute("open");
          }
        }
      });
    }
    unstickProductUi();
    window.setTimeout(unstickProductUi, 300);
    window.setTimeout(unstickProductUi, 1200);
    window.addEventListener("pageshow", unstickProductUi);
  }

  var navApplyTimer = null;
  var navApplying = false;
  function scheduleNavActive() {
    if (navApplying) return;
    if (navApplyTimer) window.clearTimeout(navApplyTimer);
    navApplyTimer = window.setTimeout(function () {
      if (navApplying) return;
      navApplying = true;
      try {
        setupNavActive();
      } finally {
        window.setTimeout(function () {
          navApplying = false;
        }, 120);
      }
    }, 250);
  }

  document.addEventListener(
    "click",
    function (event) {
      var t = event.target;
      if (!(t instanceof Element)) return;
      /* Never re-run setupNavActive on hamburger open — DOM thrash closed the
         drawer ~250ms after open (debug fc86b3 drawer blink). */
      if (
        t.closest(
          "summary.header__icon--menu, summary.header__icon--summary, .header__icon--menu, button.header__icon--menu",
        )
      ) {
        return;
      }
      if (
        t.closest(
          'button[aria-controls*="menu" i], [data-drawer-trigger], button.menu-drawer-button'
        )
      ) {
        scheduleNavActive();
      }
    },
    true
  );

  try {
    var headerRoot = document.querySelector("#header-group, header, .header-section");
    if (headerRoot) {
      var headerMo = new MutationObserver(function () {
        if (navApplying) return;
        scheduleNavActive();
      });
      // subtree:false avoids feedback loops when we tweak link attributes deep in the header
      headerMo.observe(headerRoot, { childList: true, subtree: false });
    }
  } catch (err) {
    /* ignore */
  }
})();

  // Guarantee footer newsletter submit button text says 'Join'
  (function ensureFooterJoinBtn() {
    function setJoinText() {
      var spans = document.querySelectorAll(".selfabout-site-footer__newsletter-submit-text");
      for (var i = 0; i < spans.length; i++) {
        if (spans[i].textContent.trim() === "Go") {
          spans[i].textContent = "Join";
        }
      }
    }
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", setJoinText);
    } else {
      setJoinText();
    }
    window.addEventListener("load", setJoinText);
  })();

  // Clean initial page load scroll position — ensure top navbar/hero always shows first
  (function ensurePageTopOnBoot() {
    if (window.location.hash === "#selfabout-site-footer") {
      try {
        history.replaceState(null, "", window.location.pathname + window.location.search);
      } catch (_e) {}
    }
    function resetTop() {
      var scroller = document.getElementById("sa-content-scroll");
      if (scroller && window.location.hash !== "#selfabout-faq") {
        scroller.scrollTop = 0;
      }
    }
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", resetTop);
    } else {
      resetTop();
    }
  })();
